import { DashboardLayout } from "layouts/dashboard.layout";
import { WithdrawalTable } from "./components/withdrawals-table.component";
import { WalletConfig } from "./components/wallet-config.component";
import { BenefitInfo } from "./components/benefit-info.component";
import { WithdrawalModal } from "./components/withdrawal-modal";
import { getCustomerDataForPayouts } from "services/customers/customers.services";
import { sharingInformationService } from "./sharingInfo.service";
import { useEffect, useState } from "react";
import { getTransactionMethods } from "../../../../services/transactions/transactions.service";

export function WithdrawalsPage() {
  const [ibInfo, setIbInfo] = useState({});
  const [txMethod, setTxMethod] = useState({});

  useEffect(() => {
    const subscription = sharingInformationService.getSubject().subscribe((data) => {
      fetchInfo();
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const fetchInfo = async () => {
    const { data } = await getCustomerDataForPayouts();
    setIbInfo(data.item);
  };

  const fetchMethods = async () => {
    const { data } = await getTransactionMethods();
    setTxMethod(data.item);
  };

  useEffect(() => {
    fetchInfo();
    fetchMethods();
  }, []);

  return (
    <DashboardLayout>
      <BenefitInfo ibInfo={ibInfo} />
      <WalletConfig
        currency={txMethod.currencies?.find(
          (item) => item.id === txMethod?.configuration?.allowedCurrencies[0]
        )}
      />
      <WithdrawalModal ibInfo={ibInfo} txMethod={txMethod}/>
      <WithdrawalTable />
    </DashboardLayout>
  );
}
